import { memo, useCallback } from 'react';
import { TableProps } from '../..';
import { Flex } from '@chakra-ui/react';
import * as Styles from '../../styles';
import { useHistory } from 'react-router';
import { IUsersTable } from 'types/usersTable';

interface BodyProps {
  rows: TableProps['rows'];
  sizes: string;
  row: TableProps['row'];
  path?: string | undefined;
  locations?: string[];
  data?: IUsersTable;
  enabled: boolean[];
  id: number[];
}

const BodyComponent: React.FC<BodyProps> = ({
  rows,
  sizes,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  row,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  path,
  locations,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  data,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  enabled,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  id,
}) => {
  const history = useHistory();

  const clickHandle = useCallback(
    index => {
      if (locations) history.push(locations[index]);
    },
    [locations],
  );

  return (
    <Styles.TableBody>
      {rows.map((tr, trIndex) => (
        <Flex
          key={trIndex}
          align={'center'}
          marginBottom={'10px'}
          cursor={locations ? 'pointer' : ''}
          onClick={() => clickHandle(trIndex)}
        >
          <Styles.Tr sizes={sizes} key={`tr-${trIndex}`}>
            {tr.map((td, tdIndex) => (
              <Styles.Td key={`td-${tdIndex}`}>{td || '-'}</Styles.Td>
            ))}
          </Styles.Tr>
        </Flex>
      ))}
    </Styles.TableBody>
  );
};

export const Body = memo(BodyComponent);
